'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _icon = require('@alicd/next/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _moment = require('@alicd/next/lib/moment');

var _moment2 = _interopRequireDefault(_moment);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _calendarMixin = require('../calendar-mixin');

var _calendarMixin2 = _interopRequireDefault(_calendarMixin);

var _util = require('../../util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarBody = function (_Component) {
    (0, _inherits3.default)(CalendarBody, _Component);

    function CalendarBody(props) {
        (0, _classCallCheck3.default)(this, CalendarBody);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CalendarBody.__proto__ || (0, _getPrototypeOf2.default)(CalendarBody)).call(this, props));

        _this.state = {
            value: props.value,
            base: props.base,
            mode: props.mode,
            hoveredDateTS: 0
        };

        _this.handleDateMouseEnter = _this.handleDateMouseEnter.bind(_this);
        _this.handleDateMouseLeave = _this.handleDateMouseLeave.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(CalendarBody, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if ('value' in newProps) {
                this.setState({
                    value: newProps.value
                });
            }

            if ('base' in newProps) {
                this.setState({
                    base: newProps.base
                });
            }

            if ('mode' in newProps) {
                this.setState({
                    mode: newProps.mode
                });
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(key, nextValue) {
            var _state = this.state,
                base = _state.base,
                value = _state.value;


            switch (key) {
                case 'decade':
                    base = (0, _moment2.default)(base).year(nextValue);
                    break;
                case 'year':
                    if (value instanceof Array) {
                        base = (0, _moment2.default)(base).year(nextValue);
                    } else {
                        value = (0, _moment2.default)(value).year(nextValue);
                    }
                    break;
                case 'month':
                    if (value instanceof Array) {
                        base = (0, _moment2.default)(base).year(nextValue.year).month(nextValue.month);
                    } else {
                        value = (0, _moment2.default)(value).year(nextValue.year).month(nextValue.month);
                    }
                    break;
                case 'date':
                    if (value instanceof Array) {
                        var _nextValue = nextValue,
                            year = _nextValue.year,
                            month = _nextValue.month,
                            date = _nextValue.date;

                        nextValue = (0, _moment2.default)().year(nextValue.year).month(nextValue.month).date(nextValue.date);

                        if (value[0] && !value[1] && value[0].valueOf() <= nextValue.valueOf()) {
                            value[1] = nextValue;
                        } else if (value[0] && !value[1] && value[0].valueOf() > nextValue.valueOf()) {
                            value[0] = nextValue;
                        } else {
                            value = [nextValue, ''];
                        }
                    } else {
                        value = (0, _moment2.default)(value).year(nextValue.year).month(nextValue.month).date(nextValue.date);
                        value = (0, _util.normalizeWeekday)(value, this.props.selectWeek);
                    }
                    break;
                default:
                    break;
            }

            this.props.onChange({
                base: base,
                value: value,
                mode: key
            });
        }
    }, {
        key: 'handleDateMouseEnter',
        value: function handleDateMouseEnter(date) {
            if (this.props.selectWeek) {
                this.setState({ hoveredDateTS: date });
            }
        }
    }, {
        key: 'handleDateMouseLeave',
        value: function handleDateMouseLeave(date) {
            if (this.props.selectWeek) {
                this.setState({ hoveredDateTS: 0 });
            }
        }
    }, {
        key: 'getDatePanel',
        value: function getDatePanel() {
            var _props = this.props,
                prefix = _props.prefix,
                rangeMode = _props.rangeMode,
                language = _props.language,
                locale = _props.locale,
                dateCellRender = _props.dateCellRender;
            var _state2 = this.state,
                base = _state2.base,
                value = _state2.value;

            // get calendar

            var calendar = this.getCalendar(base, language, locale);
            var weekHtml = [];
            var monthHtml = [];

            for (var windex = 0; windex < calendar.length; windex++) {
                var week = calendar[windex];

                for (var dindex = 0; dindex < week.length; dindex++) {
                    var _classNames;

                    var dayBase = week[dindex].base,
                        dayValue = week[dindex].value,
                        isToday = false,
                        isSelectedDate = false,
                        isRangeDate = false,
                        isAllowedDate = this.isAllowedDate(dayValue);

                    // 进行各种校验
                    if (value instanceof Array) {
                        var rangeStart = value[0] ? value[0].valueOf() : null;
                        var rangeEnd = value[1] ? value[1].valueOf() : null;

                        isSelectedDate = this.isSameDay(dayValue.timestamp, rangeStart) || this.isSameDay(dayValue.timestamp, rangeEnd);
                        isRangeDate = rangeStart && rangeEnd && this.isRangeDay(dayValue.timestamp, [rangeStart, rangeEnd]);
                    } else if (!this.props.selectWeek) {
                        isSelectedDate = this.isSameDay(dayValue.timestamp, value.valueOf());
                    } else {
                        var range = (0, _util.getWeekRange)((0, _moment2.default)(value.valueOf()), this.props.selectWeek);
                        isSelectedDate = this.isSameDay(dayValue.timestamp, range[0]) || this.isSameDay(dayValue.timestamp, range[1]);
                        isRangeDate = this.isRangeDay(dayValue.timestamp, range);
                    }

                    isToday = this.isSameDay(dayValue.timestamp, (0, _moment2.default)().valueOf());

                    var cellCls = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, prefix + 'calendar-cell', true), (0, _defineProperty3.default)(_classNames, prefix + 'calendar-cell-prev-month', dayValue.month < dayBase.month), (0, _defineProperty3.default)(_classNames, prefix + 'calendar-cell-next-month', dayValue.month > dayBase.month), (0, _defineProperty3.default)(_classNames, prefix + 'calendar-cell-today', isToday && !this.props.selectWeek), (0, _defineProperty3.default)(_classNames, prefix + 'calendar-cell-selected', isSelectedDate), (0, _defineProperty3.default)(_classNames, prefix + 'calendar-cell-range', isRangeDate), (0, _defineProperty3.default)(_classNames, prefix + 'calendar-cell-range-mode', rangeMode), (0, _defineProperty3.default)(_classNames, prefix + 'calendar-cell-disabled', !isAllowedDate), (0, _defineProperty3.default)(_classNames, "cn-calex-cal-cell-hovered-week", this.props.selectWeek && this.state.hoveredDateTS && !isSelectedDate && !isRangeDate && (0, _util.isRangeWeek)((0, _moment2.default)(dayValue.timestamp), (0, _moment2.default)(this.state.hoveredDateTS), this.props.selectWeek, "[]")), _classNames));
                    var dateAttrs = {
                        title: dayValue.year + '-' + (dayValue.month + 1) + '-' + dayValue.date,
                        onClick: isAllowedDate ? this.onChange.bind(this, 'date', dayValue) : null
                    };

                    weekHtml.push(_react2.default.createElement(
                        'td',
                        { key: dindex, className: cellCls },
                        _react2.default.createElement(
                            'div',
                            (0, _extends3.default)({}, dateAttrs, { className: prefix + 'calendar-date',
                                onMouseEnter: this.handleDateMouseEnter.bind(null, dayValue.timestamp),
                                onMouseLeave: this.handleDateMouseLeave.bind(null, dayValue.timestamp)
                            }),
                            dateCellRender ? dateCellRender(dayValue) : dayValue.date
                        )
                    ));
                }

                monthHtml.push(_react2.default.createElement(
                    'tr',
                    { key: windex },
                    weekHtml
                ));
                weekHtml = [];
            }

            return monthHtml;
        }
    }, {
        key: 'getMonthPanel',
        value: function getMonthPanel() {
            var _this2 = this;

            var _props2 = this.props,
                prefix = _props2.prefix,
                locale = _props2.locale,
                language = _props2.language,
                monthCellRender = _props2.monthCellRender;
            var _state3 = this.state,
                base = _state3.base,
                value = _state3.value;

            // get locale

            var monthsLocale = locale.format ? locale.format.shortMonths : this.getMonthsLocale(language);
            var selectedMonth = value instanceof Array ? '' : value.month();

            // monthsLocale 0~11
            var monthHtml = [],
                yearHtml = [];

            var _loop = function _loop(mindex) {
                var _classNames2;

                var theDate = (0, _moment2.default)(base).month(mindex);
                var calendarDate = {
                    timestamp: theDate.valueOf(),
                    year: theDate.year(),
                    month: mindex,
                    date: theDate.date(),
                    week: theDate.isoWeekday(),
                    valueOf: function valueOf() {
                        return theDate.valueOf();
                    }
                };
                // 校验合法性
                var isAllowedMonth = _this2.isAllowedMonth(calendarDate);
                var monthAttrs = {
                    title: monthsLocale[mindex],
                    onClick: isAllowedMonth ? _this2.onChange.bind(_this2, 'month', calendarDate) : null
                };

                // get class
                var cellCls = (0, _classnames2.default)((_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, prefix + 'calendar-cell', true), (0, _defineProperty3.default)(_classNames2, prefix + 'calendar-cell-selected', mindex === selectedMonth), (0, _defineProperty3.default)(_classNames2, prefix + 'calendar-cell-disabled', !isAllowedMonth), _classNames2));

                monthHtml.push(_react2.default.createElement(
                    'td',
                    { key: mindex, className: cellCls },
                    _react2.default.createElement(
                        'div',
                        (0, _extends3.default)({}, monthAttrs, { className: prefix + 'calendar-month' }),
                        monthCellRender ? monthCellRender(calendarDate) : monthsLocale[mindex]
                    )
                ));

                if (mindex % 3 === 2) {
                    yearHtml.push(_react2.default.createElement(
                        'tr',
                        { key: mindex },
                        monthHtml
                    ));
                    monthHtml = [];
                }
            };

            for (var mindex = 0; mindex < monthsLocale.length; mindex++) {
                _loop(mindex);
            }

            return yearHtml;
        }
    }, {
        key: 'getYearPanel',
        value: function getYearPanel() {
            var _this3 = this;

            var _props3 = this.props,
                prefix = _props3.prefix,
                yearCellRender = _props3.yearCellRender;
            var _state4 = this.state,
                base = _state4.base,
                value = _state4.value;

            // get decade years

            var selectedYear = value instanceof Array ? '' : value.year();
            var baseYear = base.year();
            var decadeYears = this.getDecadeYears(baseYear);

            var yearHtml = [];
            var cellHtml = void 0;
            var decadeHtml = [];

            for (var i = 0; i < decadeYears.length + 2; i++) {
                var _classNames3;

                var theYear = decadeYears[i - 1];
                var isAllowedYear = true;

                if (i === 0) {
                    cellHtml = _react2.default.createElement(
                        'div',
                        { className: prefix + 'calendar-year', onClick: this.onChange.bind(this, 'decade', baseYear - 10) },
                        _react2.default.createElement(_icon2.default, { type: 'arrow-left', size: 'xs' })
                    );
                } else if (i === decadeYears.length + 1) {
                    cellHtml = _react2.default.createElement(
                        'div',
                        { className: prefix + 'calendar-year', onClick: this.onChange.bind(this, 'decade', baseYear + 10) },
                        _react2.default.createElement(_icon2.default, { type: 'arrow-right', size: 'xs' })
                    );
                } else {
                    (function () {
                        var theDate = (0, _moment2.default)(base).year(theYear);
                        var calendarDate = {
                            timestamp: theDate.valueOf(),
                            year: theYear,
                            month: theDate.month(),
                            date: theDate.date(),
                            week: theDate.isoWeekday(),
                            valueOf: function valueOf() {
                                return theDate.valueOf();
                            }
                        };

                        // 校验合法性
                        isAllowedYear = _this3.isAllowedYear(calendarDate);

                        var yearAttrs = {
                            title: theYear,
                            onClick: isAllowedYear ? _this3.onChange.bind(_this3, 'year', theYear) : null
                        };
                        cellHtml = _react2.default.createElement(
                            'div',
                            (0, _extends3.default)({}, yearAttrs, { className: prefix + 'calendar-year' }),
                            yearCellRender ? yearCellRender(calendarDate) : theYear
                        );
                    })();
                }

                var cellCls = (0, _classnames2.default)((_classNames3 = {}, (0, _defineProperty3.default)(_classNames3, prefix + 'calendar-cell', true), (0, _defineProperty3.default)(_classNames3, prefix + 'calendar-cell-selected', theYear && theYear === selectedYear), (0, _defineProperty3.default)(_classNames3, prefix + 'calendar-cell-disabled', !isAllowedYear), _classNames3));

                yearHtml.push(_react2.default.createElement(
                    'td',
                    { key: i, className: cellCls },
                    cellHtml
                ));

                if (i % 3 === 2) {
                    decadeHtml.push(_react2.default.createElement(
                        'tr',
                        { key: '3-' + i / 3 },
                        yearHtml
                    ));
                    yearHtml = [];
                }
            }

            return decadeHtml;
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames4;

            var _props4 = this.props,
                prefix = _props4.prefix,
                type = _props4.type;
            var mode = this.state.mode;

            var bodyHtml = [];

            if (mode === 'decade') {
                bodyHtml = this.getYearPanel();
            } else if (mode === 'year') {
                bodyHtml = this.getMonthPanel();
            } else if (mode === 'month') {
                bodyHtml = this.getDatePanel();
            }

            var bodyCls = (0, _classnames2.default)((_classNames4 = {}, (0, _defineProperty3.default)(_classNames4, prefix + 'calendar-tbody', true), (0, _defineProperty3.default)(_classNames4, prefix + 'calendar-' + type + '-tbody', type), (0, _defineProperty3.default)(_classNames4, "cn-calex-tbody-week", this.props.selectWeek), _classNames4));

            return _react2.default.createElement(
                'tbody',
                { className: bodyCls, ref: 'calendar-tbody' },
                bodyHtml
            );
        }
    }]);
    return CalendarBody;
}(_react.Component);

CalendarBody.propTypes = {
    type: _propTypes2.default.oneOf(['fullscreen', 'card']),
    rangeMode: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    selectWeek: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number])
};


(0, _calendarMixin2.default)(CalendarBody);

exports.default = CalendarBody;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-calendar-ex@0.0.4@@alicd/crui-calendar-ex/lib/view/table/calendar-tbody.js
// module id = 621
// module chunks = 0